<template>
  <div class="topbar">
    <b-row
      align-h="between"
      align-v="stretch"
    >
      <b-col>
        <KTQuickUser></KTQuickUser>
      </b-col>
    </b-row>
    <template v-if="isNewLayout">
      <KTMenuOptionsMore></KTMenuOptionsMore>
    </template>
  </div>
</template>

<style lang="scss">
.topbar {
  .dropdown-toggle {
    padding: 0;
    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }

  .dropdown-menu {
    margin: 0;
    padding: 0;
    outline: none;
    .b-dropdown-text {
      padding: 0;
    }
  }
}
</style>

<script>
import KTQuickUser from '@/view/layout/extras/offcanvas/QuickUser.vue';
import KTMenuOptionsMore from '@/view/layout/header/_MenuOptionsMore.vue';
import SavaDataUtil from '@/utils/saveDataToLocal';

export default {
  name: 'KTTopbar',
  data() {
    return {
      selectedMerchant: 1,
    };
  },
  mounted() {
    this.selectedMerchant = SavaDataUtil.getData('merchantId') || 1;
  },
  computed: {
    isNewLayout() {
      if (SavaDataUtil.getData('config')) return true;
      return false;
    },
  },
  components: {
    KTQuickUser,
    KTMenuOptionsMore,
  },
  methods: {
    onChangeMerchant() {
      SavaDataUtil.saveData('merchantId', this.selectedMerchant);
      this.$router.go(this.$router.currentRoute);
    },
  },
};
</script>
